import './abstract_section_view.coffee';# Added by Script 
Namespace 'Monitoring.Reports.Executive'

class Monitoring.Reports.Executive.PostsView extends Monitoring.Reports.Executive.AbstractSectionView
  template: JST["backbone/templates/monitoring/reports/executive/posts"]
  twitterTemplate:  JST['backbone/templates/monitoring/reports/executive/post_preview_twitter']
  fbTemplate: JST['backbone/templates/monitoring/reports/executive/post_preview_facebook']
  id: 'posts-egmnt'
  name: 'posts-egmnt'
  tagName: 'section'


  render: ->
    @$el.addClass(@options.section + '-section')
    @$el.html(@template(self: this))
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    fb_page = @getTemplateOptions().page
    network =  @getTemplateOptions().network

    $.post(@options.chartApi.top_five_posts + network, _.extend({page: fb_page}, query, @getExtraQuery()), (results) =>
      if results.length > 0
        @renderPosts(results)
  )

  renderPosts: (results) ->
    resultsContainer = @$el.find('#results-list')
    templates = {}
    templates['twitter'] = @twitterTemplate
    templates['facebook'] = @fbTemplate
    @renderRemaining = results.length
    for post in results
      newPost = $(templates[post.type](post: post))
      resultsContainer.append(newPost)
      if post.type == 'facebook'
        FB.Event.subscribe('xfbml.render', @resizeIframes)
        FB.XFBML.parse(newPost[0])
      else
        twttr.widgets.load(newPost[0])
        @renderRemaining--

  resizeIframes: =>
    @renderRemaining--
    posts = @$el.find('.post-cell').find('.facebook-label').parent()
    scaleFactor = @$el.width()*0.30 / 360
    for post in posts
      post = $(post)
      label = post.find('label.post-label.facebook-label')
      if label.height() < 1000 # weird facebook resize
        post.height(label.height() * scaleFactor + 10)
      cssTransform = "scale(#{scaleFactor})"
      label.css(
        'transform': cssTransform
        '-moz-transform': cssTransform
        '-webkit-transform': cssTransform
        '-o-transform': cssTransform
      )
    if @renderRemaining == 0
      FB.Event.unsubscribe('xfbml.render', @resizeIframes)
      setTimeout(@resizeIframes, 1000) # arrgg @&%!